const initialState = {
    companyname: ''
  };
  
  const companyNameReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_COMPANY_NAME':
            return { ...state, companyname: action.payload };
        default:
            return state;
    }
  };
  
  export default companyNameReducer;
  